import {put, select, take} from 'redux-saga/effects';
import {KEY as KEY_BASE} from '../constants';
import {appendLocaleMessages, setLocaleMessages} from '../actionCreatorsShared';
import {
  hasApiActionStoppedLoading,
  isSuccessApiAction
} from '../../api/helpers/actions';
import {apiGet} from '../../api/actionCreators';
import getApiData from '@shared/ducks/api/selectors/getApiData';

export const loadLocaleCreator = (onSuccess, processMessages, beforeCheck) =>
  function* doLoadLocale(action) {
    if (beforeCheck) {
      const canProceed = yield* beforeCheck();
      if (!canProceed) {
        return;
      }
    }
    const locale = encodeURIComponent(action.locale);
    const localeModule = action.localeModule || 'HpCommon';
    const url = `${action.localesPath}?locale=${locale}&category=widgets&module=${localeModule}`;
    const KEY = `${KEY_BASE}_${locale}_${localeModule}`;
    yield put(apiGet({key: KEY, url}));
    const done = yield take(hasApiActionStoppedLoading(KEY));
    if (isSuccessApiAction(KEY)(done)) {
      let messages = yield select(getApiData(KEY));
      if (processMessages) {
        messages = yield* processMessages(messages);
      }
      if (action?.appendMessages) {
        yield put(appendLocaleMessages(locale, messages));
      } else {
        yield put(setLocaleMessages(locale, messages));
      }
      if (onSuccess) {
        yield* onSuccess(locale);
      }
    }
  };
